<template>
  <div>
    <div v-for="(item, index) in fiterList" :key="index">
      <div v-if="item.status === 'SUCCESS'">
        <div class="option mb-3 selected-color success rounded px-3 py-3 flex align-start">
          <span class="mr-2 span-white font">{{ item.optionsKey }}</span>
          <span class="span-white font flex-1">{{item.optionsValue}}</span>
        </div>
      </div>

      <div v-else-if="item.status === 'ERROR'">
        <div class="option mb-3 selected-color rounded px-3 py-3 flex align-start bg-danger">
          <span class="mr-2 span-white font">{{ item.optionsKey }}</span>
          <span class="span-white font flex-1">{{item.optionsValue}}</span>
        </div>
      </div>

      <div v-else>
        <div class="option mb-3  rounded px-3 py-3 flex align-start">
          <span class="mr-2 span-dark font">{{ item.optionsKey }}</span>
          <span class="span-dark font flex-1">{{item.optionsValue}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuestionSelectOption',
  props: {
    list: {
      type: Array,
      default: () => []
    },
    userAnswers: {
      type: String,
      default: ''
    },
    correctAnswer: {
      type: String,
      default: ''
    },
    questionType: {
      type: String,
      default: ''
    },
    answerResult: {
      type: String,
      default: ''
    },
  },
  data() {
    return {}
  },
  computed: {
    fiterList() {
      return this.list.map(item => {
        // 单选 和 判断
        if (this.questionType === '1' || this.questionType === '3') {
          // 仅判断 用户选择的答案 与 当前key
          // item.status = '' 判断题
          item.status = this.userAnswers === item.optionsKey ? this.answerResult : ''
        }
        // 多选
        if (this.questionType === '2') {
          let checkUserAnswers = this.userAnswers.includes(item.optionsKey)
          let checkCorrectAnswer = this.correctAnswer.includes(item.optionsKey)
          if (item.userAnswers !== '' && checkUserAnswers === true) {
            item.status = checkCorrectAnswer === true ? 'SUCCESS' : 'ERROR'
          }
        }
        return item
      })
    }
  }
}
</script>

<style <style lang="scss"  scoped>
.option {
  width: 420px;
  height: 54px;
  background-color: #f1f3f8;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 400;
  color: #2e323c;
  display: flex;
  align-items: center;
  padding: 0 15px;
  margin: 0 auto 15px;
  border: 1px solid #f1f3f8;
  &.selected-color {
    background-color: rgba(225, 63, 55, 0.15);
    border: 1px solid #e13f37;
    color: #e13f37;
  }
}
</style>
